import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-itemwise-sales-vs-rm',
  templateUrl: './itemwise-sales-vs-rm.component.html',
  styleUrls: ['./itemwise-sales-vs-rm.component.scss']
})
export class ItemwiseSalesVsRMComponent implements OnInit {

  constructor(public appservice:AppService) { 
  }

  ngOnInit(): void {
  }

}
